module.exports = __webpack_public_path__ + "static/SE_Text-dark-91488377fd61c7b2b94d7a25af064b2e.png";